import { Box } from "@mui/material";

export const changeOrderColumns = ({ user, tableData, setTableData }) => [
  {
    accessorKey: "COData",
    header: "CO Data",
    columns: [
      {
        accessorKey: "CONumber",
        header: "CO #",
        // enableEditing: false,
        grow: false,
        size: 80,
      },
      {
        accessorKey: "date",
        header: "Date",
        // enableEditing: false,
        muiEditTextFieldProps: { type: "date" },
        grow: false,
        size: 20,
      },
      {
        accessorKey: "description",
        header: "Scope Description",
        // enableEditing: false,
        grow: false,
        size: 100,
      },
      {
        accessorKey: "by",
        header: "By",
        // enableEditing: false,
        grow: false,
        size: 80,
        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },
        // Cell: () => user?.name,
      },
    ],
  },

  {
    accessorKey: "est",
    header: "Est. Data",
    columns: [
      {
        accessorKey: "bom",
        header: "BOM",
        enableEditing: false,
        grow: false,
        size: 240,
        Cell: ({ row }) => {
          console.log("rowwwwwwws BOm:", row.original);
          const tags =
            row.original.bom?.map(
              (m) => m.tagNumbers || m.taggedMaterial?.tagNumber,
            ) || [];

          const bulkMaterials = row.original.bom?.map((m) => {
            const desc = `${m?.description || ""}, ${m?.specs?.length || ""} Ft., ${m?.weight || ""}`;
            return desc;
          });
          const isTagged =
            row.original.bom?.[0]?.tagNumbers ||
            row.original.bom?.[0]?.taggedMaterial?.tagNumber;

          const arr = isTagged ? tags : bulkMaterials;
          return (
            <Box>
              {arr.map((t) => {
                return <Box> - {t}</Box>;
              })}
            </Box>
          );
        },
      },

      {
        accessorKey: "MaterialCost",
        header: "Material Cost",
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: "number",
          onInput: (e) => {
            const value = e.currentTarget.value;
            if (value !== undefined) {
              cell.setValue(value);

              // Update state to trigger re-render
              setTableData((prev) => {
                const newData = [...prev];
                newData[row.index] = {
                  ...newData[row.index],
                  MaterialCost: value,
                };
                return newData;
              });
            }
          },
        }),
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "ManhoursCost",
        header: "Manhours Cost",
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: "number",
          onInput: (e) => {
            const value = e.currentTarget.value;
            if (value !== undefined) {
              cell.setValue(value);

              // Update state to trigger re-render
              setTableData((prev) => {
                const newData = [...prev];
                newData[row.index] = {
                  ...newData[row.index],
                  ManhoursCost: value,
                };
                return newData;
              });
            }
          },
        }),
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "OtherCost",
        header: "Other Cost",
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
        },
        muiEditTextFieldProps: ({ cell, row }) => ({
          type: "number",
          onInput: (e) => {
            const value = e.currentTarget.value;
            if (value !== undefined) {
              cell.setValue(value);

              // Update state to trigger re-render
              setTableData((prev) => {
                const newData = [...prev];
                newData[row.index] = {
                  ...newData[row.index],
                  OtherCost: value,
                };
                return newData;
              });
            }
          },
        }),
        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "Total Cost",
        header: "Total Cost",
        enableEditing: false,
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            fontWeight: 600,
            border: "0.5px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            backgroundColor: "#f3f1fe",
          },
        },
        muiTableBodyCellProps: {
          align: "center",
          sx: {
            border: "1px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            fontWeight: 600,
          },
        },
        Cell: ({ row }) => {
          console.log("rowwwww total", row.original, tableData);
          const a = Number(row.original.MaterialCost) || 0;
          const b = Number(row.original.ManhoursCost) || 0;
          const c = Number(row.original.OtherCost) || 0;

          return a + b + c || "";
        },
      },
    ],
  },

  {
    accessorKey: "Actual",
    header: "Actual Data",
    columns: [
      {
        accessorKey: "bom",
        header: "BOM",
        enableEditing: false,
        grow: false,
        size: 240,
        Cell: ({ row }) => {
          console.log("rowwwwwwws BOm:", row.original);
          const tags =
            row.original.bom?.map(
              (m) => m.tagNumbers || m.taggedMaterial?.tagNumber,
            ) || [];

          const bulkMaterials = row.original.bom?.map((m) => {
            const desc = `${m?.description || ""}, ${m?.specs?.length || ""} Ft., ${m?.weight || ""}`;
            return desc;
          });
          const isTagged =
            row.original.bom?.[0]?.tagNumbers ||
            row.original.bom?.[0]?.taggedMaterial?.tagNumber;

          const arr = isTagged ? tags : bulkMaterials;
          return (
            <Box>
              {arr.map((t) => {
                return <Box> - {t}</Box>;
              })}
            </Box>
          );
        },
      },
      {
        accessorKey: "Material Cost",
        header: "Material Cost",
        enableEditing: false,

        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },
        Cell: ({ row }) => {
          let totalCost = 0;

          row.original.bom?.forEach((m) => {
            const cost = m?.mrqMaterials?.[0]?.poMaterials?.[0]?.cost;
            cost && (totalCost += Number(cost));
          });
          return totalCost;
        },
      },
      {
        accessorKey: "Manhours Cost",
        header: "Manhours Cost",
        enableEditing: false,
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "Other Cost",
        header: "Other Cost",
        enableEditing: false,
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },
      },
      {
        accessorKey: "Total Cost",
        header: "Total Cost",
        enableEditing: false,
        grow: false,
        size: 20,
        muiTableHeadCellProps: {
          align: "center",
          sx: {
            fontWeight: 600,
            border: "0.5px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            backgroundColor: "#f3f1fe",
          },
        },

        muiTableBodyCellProps: {
          align: "center",
          sx: {
            border: "1px solid rgba(81, 81, 81, .1)",
            padding: "10px",
            fontWeight: 600,
          },
        },
        Cell: ({ row }) => {
          let materialsCost = 0;

          row.original.bom?.forEach((m) => {
            const cost = m?.mrqMaterials?.[0]?.poMaterials?.[0]?.cost;
            cost && (materialsCost += Number(cost));
          });

          return materialsCost;
        },
      },
    ],
  },

  // {
  //   accessorKey: "more",
  //   header: "",
  //   columns: [
  //     {
  //       accessorKey: "Remarks",
  //       header: "Remarks",
  //       // enableEditing: false,
  //       grow: false,
  //       size: 20,
  //     },
  //   ],
  // },
];
